/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CategoryMoving: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.5 4C1.5 3.44772 1.94772 3 2.5 3H21.5C22.0523 3 22.5 3.44772 22.5 4V8C22.5 8.55228 22.0523 9 21.5 9H21V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9H2.5C1.94772 9 1.5 8.55228 1.5 8V4ZM5 9H19V20H5V9ZM20.5 7H20H4H3.5V5H20.5V7ZM10 11.5C9.44772 11.5 9 11.9477 9 12.5C9 13.0523 9.44772 13.5 10 13.5H14C14.5523 13.5 15 13.0523 15 12.5C15 11.9477 14.5523 11.5 14 11.5H10Z'
      fill='currentColor'
    />
  </React.Fragment>
)
